<template>
<div class="policy-inspection">
  <div class="policy-title">
    保单验真
  </div>
  <div class="policy-list">
    <div v-for="(item, index) in list" :key="index" class="policy-item">
      <div v-html="item.html" class="policy-content"></div>
    </div>
  </div>
</div>
</template>

<script>
import companys from '@/service/companys'
export default {
  components: {
  },
  data () {
    return {
      show: 1,
      list: companys.map(item => {
        return {
          name: item.title,
          html: item.html
        }
      }),
      html: ''
    }
  },
  methods: {
    onSelect (item) {
      this.show = 2
      let obj = companys.find(x => {
        return x.title === item.name
      })
      this.html = obj.html
    }
  },
  mounted () {
    console.log(companys)
  }
}
</script>

<style lang="scss">
.policy-inspection {
  width: 900px;
  padding: 0 20px;
  background:rgba(255,255,255,1);
  box-shadow:0px 16px 24px -4px rgba(137,154,230,0.08);
  border:1px solid rgba(236,238,243,0.96);

  .policy-title {
    font-size: 20px;
    padding: 20px 0;
    border-bottom: 1px solid rgba(105,108,141,0.2);
    font-family:PingFangSC-Medium,PingFang SC;
    font-weight:500;
    color:rgba(105,108,141,1);
    line-height:14px;
  }
  .policy-content {
    margin: 35px 17px;

    .box_tit {
      font-size:16px;
      font-family:PingFangSC-Medium,PingFang SC;
      font-weight:500;
      color:rgba(105,108,141,1);
      line-height:14px;
    }

    .box_subtit {
      font-size:14px;
      font-family:PingFangSC-Medium,PingFang SC;
      font-weight:500;
      color:rgba(105,108,141,1);
      line-height:24px;
      margin: 13px 0;

      a {
        color: #FEDD00;
        text-decoration: none;
      }
    }
  }
}
</style>
